
import { Nav } from './components/nav'
import { Home } from './pages/home'
import { About } from './pages/about'
import { Process } from './pages/process'

// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

class App {
  constructor() {
    const nav = new Nav;

    // Initialize Home page
    if(document.querySelector('.template-home')) {
      const home = new Home;
    }

    // Initialize About page
    if(document.querySelector('.template-about')) {
      const about = new About;
    }

    // Initialize Process page
    if(document.querySelector('.template-process')) {
      const process = new Process;
    }

    // if(document.querySelector('.dropdown')) {
    //   const dropdown = new DropDown;
    // }
    // if(document.querySelector('.popup')) {
    //   const popup = new PopUp;
    // }
  }
}

window.onload = function() {
  let app = new App();
};
